export enum MappingSteps {
  SELECT_MAPPING = 0,
  EXECUTION_FORM,
  TEMPLATE_BATCH,
  RESULT_BATCH
}
